import { fetchPlans } from 'nove8/helpers/api/fetchPlans'
import { useEffect } from 'react'
import { useZustandStore } from 'zustandGlobalStore'

export const useGetPlans = (): void => {
  const cohortLeadId = useZustandStore((state) => state.lead?.cohortLeadId)

  useEffect(() => {
    if (!cohortLeadId) return
    fetchPlans(cohortLeadId)
  }, [cohortLeadId])
}
